import { useContext } from 'react';

import { AppSyncContext } from '../context/appsync';

export function useAppSync() {
  return useContext(AppSyncContext);
}
